import React from 'react'
import { selectCarregandoPlataformas } from 'store/slices/plataformaSlice'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@mui/material'
import { SemPlataformas, ItemLista } from './NenhumaPlataforma.styles'
import { useSelector } from 'react-redux'

export function NenhumaPlataforma() {
  const carregando = useSelector(selectCarregandoPlataformas)
  const { t } = useTranslation('translation', {
    keyPrefix: 'componentes.menu_lateral'
  })

  return (
    <>
      {carregando ? (
        <ItemLista>
          <Skeleton
            variant="rounded"
            height={24}
            width={311}
            animation="wave"
          />
        </ItemLista>
      ) : (
        <ItemLista>
          <SemPlataformas> {t('sem_plataformas')} </SemPlataformas>
        </ItemLista>
      )}
    </>
  )
}
